import { Button } from '@mui/material';
import { useRef } from 'react';
import styled from 'styled-components';

export const FlexColumnCentered = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	button {
		font-size: 20px;
	}
`;

const Config = styled(FlexColumnCentered)`
	textarea {
		width: 80vw;
		height: 20vw;
	}

	gap: 20px;
`;

export const ConfigureApp = () => {
	const ref = useRef();
	return (
		<Config>
			<h1>Configure App - Paste Exact Config in Box, Hit Save</h1>
			<textarea ref={ref} />
			<Button
				variant="outlined"
				onClick={() => window.localStorage.setItem('config', ref.current.value)}
			>
				Save
			</Button>
		</Config>
	);
};
